module.exports = __webpack_public_path__ + "img/408ff219b420be869f5c045bf3aa4438.51645420.png";